import swal from 'sweetalert';
import 'sweetalert/dist/sweetalert.css';

AlertsService.$inject = [];

function AlertsService() {
    this.show = swal;

    this.error = err => {
        console.log(err);

        const message = {
            title: 'Error!',
            type: 'error',
            text: 'Something went wrong with this request.'
        };

        //TODO:  This could/should be much improved I think (MRD)
        if (err.data) {
            let reasons;
            if (err.data.constructor === Array) {
                reasons = '<ul><li>' + err.data.join('</li><li>') + '</li></ul>';
            } else if (err.data.violations && err.data.violations.constructor === Array) {
                message.title = 'Oops!';
                message.type = '';
                message.text = 'The shift could not be created for the following reasons:';
                reasons = '<ul><li>' + err.data.violations.join('</li><li>') + '</li></ul>';                
            }
            message.text += reasons;
            message.html = true;
        } else if (typeof err === 'string') {
            message.text = makeAzureErrorFriendly(err);
        } else {
            let innerMessage = err.data && err.data.message || err.message || err.statusText || 'Unknown Error';
            // Override Azure specific error messages with friendly error
            innerMessage = makeAzureErrorFriendly(innerMessage);
            message.text += ' (' + innerMessage + ')';
        }

        swal(message);
        return err;
    };

    function makeAzureErrorFriendly(errorString) {
        if (errorString.startsWith('AADSTS')) {
            return 'Authentication error. Please try logging in again.';
        }
        return errorString;
    }

    this.showTimedSuccessMessage = (message) => {
        this.show({
            text: message,
            type: 'success',
            title: 'Success',
            timer: 1500,
            showConfirmButton: false
        });
    };
    
    this.showConfirmDialog = (confirmationText, confirmationButtonText, confirmHandler) => {
        this.show({
            type: 'warning',
            title: 'Are you sure?',
            text: confirmationText,
            confirmButtonText: confirmationButtonText,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            closeOnConfirm: false
        }, confirmHandler);
    };

}

export default AlertsService;



// WEBPACK FOOTER //
// ./src/js/services/alerts/index.js